import Dashboard from "../modules/Dashboard";

function DashboardPage() {
  return (
    <div className="">
      <Dashboard />
    </div>
  );
}

export default DashboardPage;
